import React from 'react';
import { Snackbar, Alert, Button } from '@mui/material';
import useVersionCheck from '../hooks/useVersionCheck';

function UpdateNotification() {
  const { updateAvailable, reloadApp } = useVersionCheck(30000); // Check every 30 seconds
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    if (updateAvailable) {
      setOpen(true);
    }
  }, [updateAvailable]);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  return (
    <Snackbar 
      open={open} 
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert 
        severity="info" 
        onClose={handleClose}
        action={
          <Button color="inherit" size="small" onClick={reloadApp}>
            UPDATE NOW
          </Button>
        }
      >
        A new version is available. Please update to get the latest features.
      </Alert>
    </Snackbar>
  );
}

export default UpdateNotification;